import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {

  [types.FETCH_MONITORING_HISTORIES](state, histories) {
    Vue.set(state, 'monitoringHistories', histories);
  },

  [types.UPDATE_MONITORING_HISTORY](state, histories) {
    Vue.set(state, 'updatedMonitoringHistories', histories);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/video-lecture/store/mutations.js